import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

// import Swal from 'sweetalert2';
import ResetPasswordForm from '@/components/Auth/ResetPasswordForm';
import { type ResetPasswordValues } from '@/components/Auth/ResetPasswordForm.schema';
import auth from '@/helpers/auth';

const ChangePasswordPage = function () {
    const navigate = useNavigate();
    const [
        t,
    ] = useTranslation('pages');
    const [
        searchParams,
    ] = useSearchParams();
    const token = searchParams.get('token');

    const submit = async (values: Partial<ResetPasswordValues>) => {
        return await axios.patch(`/api/auth/reset-password`, {
            token: token,
            ...values,
        }).then(() => {
            // Swal.fire({
            //     title: 'Success!',
            //     text: `Password has been changed, please log in.`,
            //     icon: 'success',
            // });

            auth.clearSession();

            navigate('/login');
        }).catch(() => {
            // Swal.fire({
            //     title: 'Error!',
            //     text: `Reset failed.`,
            //     icon: 'error',
            //     confirmButtonText: 'OK, I\'ll try again',
            // });
        });
    };

    const goBack = () => {
        navigate('/login');
    };

    return (
        <div className='max-w-md'>
            <h2 className='mb-6 text-center text-3xl font-bold tracking-tight text-foreground'>
                {t('Set your new password')}
            </h2>

            <ResetPasswordForm onCancel={ goBack } onSubmit={ submit } />
        </div>
    );
};

export default ChangePasswordPage;
